export default __webpack_public_path__ + "static/media/MEN-SEXUALLY-TRANSMITTED-DISEASES.f0364f3d.png";